module.exports = __webpack_public_path__ + "media/components/src/assets/images/back-arrow/arrow-back-52684c9dd4da7af3ddd29e8d19508c7a.svg";